import { useCallback, useEffect, useRef } from 'react';

export const useSeek = (video: HTMLVideoElement | null) => {
  const seekRef = useRef<HTMLDivElement>(null);
  const draggingRef = useRef(false);

  const seek = useCallback(
    (clientX: number) => {
      const bar = seekRef.current;

      if (!video || !bar) {
        return;
      }

      const rect = bar.getBoundingClientRect();

      const ratio = Math.min(
        Math.max((clientX - rect.left) / rect.width, 0),
        1
      );

      video.currentTime = ratio * video.duration;
    },
    [video]
  );

  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      if (!draggingRef.current) {
        return;
      }

      seek(e.clientX);
    };

    const onUp = () => {
      draggingRef.current = false;
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);

    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
  }, [seek]);

  const handleMouseDown = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      draggingRef.current = true;
      seek(e.clientX);
    },
    [seek]
  );

  return {
    seekRef,
    seekBarProps: {
      onMouseDown: handleMouseDown,
    },
  };
};
